import React, { useEffect, useState } from "react";
import {
  AppstoreFilled,
  HomeFilled,
  SearchOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import { Input, Menu } from "antd";
import { useNavigate } from "react-router";
import SloganBanner from "../components/home/SloganBanner";

import { ImHammer2 } from "react-icons/im";
import { BsFillBuildingsFill } from "react-icons/bs";

import { Dropdown } from "antd";

import { MdAdminPanelSettings, MdCreditCard } from "react-icons/md";

export default function Header() {
  const { SubMenu } = Menu;
  const navigate = useNavigate();
  const handleMenuClick = (path) => {
    navigate(path);
  };
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const toggleSearch = () => {
    setIsSearchOpen(!isSearchOpen);
  };
  const logout = () => {
    localStorage.removeItem("userId");
    localStorage.removeItem("adminId");
    localStorage.removeItem("subadminId");
    navigate("/");
  };

  const [hasSubAdminId, setHasSubAdminId] = useState(false);
  const checkSubAdminId = () => {
    return localStorage.getItem("subadminId");
  };
  useEffect(() => {
    setHasSubAdminId(checkSubAdminId());
  }, []);

  const items = [
    !hasSubAdminId && {
      key: "4",
      label: <div onClick={() => navigate("/payment_method")}> Payments</div>,
    },
    {
      key: "5",
      label: <div onClick={logout}>Log Out</div>,
    },
  ];
  const [hasAdminId, setHasAdminId] = useState(false);
  const checkAdminId = () => {
    return localStorage.getItem("adminId");
  };
  useEffect(() => {
    setHasAdminId(!!checkAdminId());
  }, []);

  return (
    <div>
      <SloganBanner />
      <div className="mainheader">
        <Menu mode="horizontal" className="navbar">
          <SubMenu
            key="Dashboard"
            icon={<AppstoreFilled style={{ fontSize: "20px" }} />}
            title="Dashboard"
          >
            <Menu.Item
              key="buildingqview"
              className="menu-item"
              onClick={() => handleMenuClick("/record_view_BuildingQuickview")}
            >
              Building Quickview
            </Menu.Item>
          </SubMenu>

          <SubMenu
            key="dob"
            title="DOB"
            icon={<BsFillBuildingsFill style={{ fontSize: "16px" }} />}
          >
            <Menu.Item
              key="violations"
              className="menu-item"
              onClick={() => navigate("/violations")}
            >
              Violations
            </Menu.Item>
            <Menu.Item
              key="swo/vo"
              className="menu-item"
              onClick={() => navigate("/swo/Vo")}
            >
              SWO/VO
            </Menu.Item>
            <Menu.Item
              key="complaints"
              className="menu-item"
              onClick={() => navigate("/live-Dob-Complaints")}
            >
              Complaints
            </Menu.Item>
          </SubMenu>
          <SubMenu key="ecbdfghj" title="ECB" icon={<ImHammer2 />}>
            <SubMenu key="hearings" title="Hearings">
              <Menu.Item
                key="allhearings"
                className="menu-item"
                onClick={() => navigate("/allHearing")}
              >
                * ALL *
              </Menu.Item>
            </SubMenu>
            <SubMenu key="correction" title="Violations">
              <Menu.Item
                key="allviolations"
                onClick={() => handleMenuClick("/violations_all")}
                className="menu-item"
              >
                * ALL *
              </Menu.Item>
            </SubMenu>
            {/*.......... Dues NAV ITEM ................*/}

            <SubMenu key="dues" title="Dues">
              <Menu.Item
                key="alldues"
                className="menu-item"
                onClick={() => navigate("/all_Dues")}
              >
                All Due
              </Menu.Item>
            </SubMenu>
          </SubMenu>

          {/* FDNY NAV ITEM */}

          {/*.......... HPD NAV ITEM ................*/}
          <SubMenu key="hpd" title="HPD" icon={<HomeFilled />}>
            <Menu.Item
              key="liveviolations"
              onClick={() => navigate("/live_Vuilations")}
              className="menu-item"
            >
              Live Violations
            </Menu.Item>

            <Menu.Item
              key="hdpcomplaints"
              onClick={() => navigate("/HDP_Complaints")}
              className="menu-item"
            >
              Complaints
            </Menu.Item>

            <Menu.Item
              key="litigations"
              onClick={() => navigate("/litigations")}
              className="menu-item"
            >
              Litigations
            </Menu.Item>

            <Menu.Item
              key="registerations"
              onClick={() => navigate("/registerations")}
              className="menu-item"
            >
              Registrations
            </Menu.Item>
          </SubMenu>

          {/*.......... Inspections NAV ITEM ................*/}

          {/*.......... PERMITS NAV ITEM ................*/}

          {/*..........Reports APPLICATIONS NAV ITEM ................*/}

          <SubMenu
            key="subadmins"
            title="Roles"
            icon={<MdAdminPanelSettings />}
          >
            <Menu.Item
              key="admin"
              onClick={() => navigate("/admins_all")}
              className="menu-item"
            >
              Admins
            </Menu.Item>
            <Menu.Item
              key="sub-admin"
              onClick={() => navigate("/subadmins_all")}
              className="menu-item"
            >
              Sub Admin
            </Menu.Item>
          </SubMenu>
          {!hasAdminId && (
            <SubMenu
              key="subscription"
              title="Subscription"
              icon={<MdCreditCard />}
            >
              <Menu.Item
                key="admin"
                onClick={() => navigate("/Propertytier")}
                className="menu-item"
              >
                Packages
              </Menu.Item>
            </SubMenu>
          )}
        </Menu>
        <div className="headericons">
          {/* <div className="search-icon">
            <SearchOutlined onClick={toggleSearch} />
          </div> */}
          {/* <div className="vertical-line"></div> */}
          <div className="menu-icon">
            <Dropdown
              menu={{
                items,
              }}
              placement="bottom"
              arrow
            >
              <MenuOutlined />
            </Dropdown>
          </div>
        </div>
      </div>

      <div className="main-serach">
        {isSearchOpen && (
          <div className="search-input" style={{ marginTop: "20px" }}>
            <Input type="text" placeholder="Search..." />
          </div>
        )}
      </div>
    </div>
  );
}
